import React, { useEffect, useState, useCallback } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { Popconfirm } from "antd";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:8011";

const Setting = () => {
  const [category, setCategory] = useState("");
  const [person, setPerson] = useState("");
  const [project, setProject] = useState("");
  const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);
  const [isPersonModalOpen, setIsPersonModalOpen] = useState(false);
  const [isProjectModalOpen, setIsProjectModalOpen] = useState(false);
  const [isPersonListModalOpen, setIsPersonListModalOpen] = useState(false);
  const [isProjectListModalOpen, setIsProjectListModalOpen] = useState(false);
  const [isCategoryListModalOpen, setIsCategoryListModalOpen] = useState(false);
  const [persons, setPersons] = useState([]);
  const [projects, setProjects] = useState([]);
  const [categories, setCategories] = useState([]);

  const navigate = useNavigate();

  const handleCategoryChange = (event) => {
    setCategory(event.target.value);
  };
  const handlePersonChange = (event) => {
    setPerson(event.target.value);
  };
  const handleProjectChange = (event) => {
    setProject(event.target.value);
  };

  const handleSaveCategory = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Please log in to add a category.");
      navigate("/signIn");
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/categories/addCategory`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ category }),
      });

      if (response.ok) {
        toast.success("Category added successfully!");
        setCategory("");
        setIsCategoryModalOpen(false);
      } else {
        const errorData = await response.json();
        toast.error(`Failed to add category: ${errorData.message}`);
      }
    } catch (error) {
      toast.error("An error occurred while adding category.");
      console.error("Add category error:", error);
    }
  };

  const handleSavePerson = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Please log in to add  person.");
      navigate("/signIn");
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/persons/addPerson`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ person }),
      });

      if (response.ok) {
        toast.success("Person added successfully!");
        setPerson("");
        setIsPersonModalOpen(false);
      } else {
        const errorData = await response.json();
        toast.error(`Failed to add person: ${errorData.message}`);
      }
    } catch (error) {
      toast.error("An error occurred while adding person.");
      console.error("Add person error:", error);
    }
  };

  const handleSaveProject = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Please log in to add  project.");
      navigate("/signIn");
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/projects/addProject`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ project }),
      });

      if (response.ok) {
        toast.success("Project added successfully!");
        setProject("");
        setIsProjectModalOpen(false);
      } else {
        const errorData = await response.json();
        toast.error(`Failed to add project: ${errorData.message}`);
      }
    } catch (error) {
      toast.error("An error occurred while adding project.");
      console.error("Add project error:", error);
    }
  };

  const fetchPersons = useCallback(async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/persons/getAllPersons`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        console.log("Fetched Persons:", data.persons);
        setPersons(data || []);
      } else {
        const errorData = await response.json();
        toast.error(`Failed to fetch persons: ${errorData.message}`);
      }
    } catch (error) {
      toast.error("An error occurred while fetching persons.");
      console.error("Fetch persons error:", error);
    }
  }, []);
  const handleDeletePerson = async (id) => {
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Please log in to delete a person.");
      navigate("/signIn");
      return;
    }

    try {
      const response = await fetch(
        `${API_BASE_URL}/persons/deletePerson/${id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        toast.success("Person deleted successfully!");
        setPersons((prevPersons) =>
          prevPersons.filter((person) => person._id !== id)
        );
      } else {
        const errorData = await response.json();
        toast.error(`Failed to delete person: ${errorData.message}`);
      }
    } catch (error) {
      toast.error("An error occurred while deleting person.");
      console.error("Delete person error:", error);
    }
  };
  const openPersonListModal = () => {
    fetchPersons();
    setIsPersonListModalOpen(true);
  };

  const fetchCategories = async () => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/categories/getAllCategories`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response.ok) {
        const data = await response.json();
        console.log("Fetched Categories:", data.persons);
        setCategories(data || []);
      } else {
        const errorData = await response.json();
        toast.error(`Failed to fetch categories: ${errorData.message}`);
      }
    } catch (error) {
      toast.error("An error occurred while fetching categories.");
      console.error("Fetch categories error:", error);
    }
  };
  const handleDeleteCategory = async (id) => {
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Please log in to delete a category.");
      navigate("/signIn");
      return;
    }

    try {
      const response = await fetch(
        `${API_BASE_URL}/categories/deleteCategory/${id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        toast.success("Category deleted successfully!");
        setCategories((prevCategories) =>
          prevCategories.filter((category) => category._id !== id)
        );
      } else {
        const errorData = await response.json();
        toast.error(`Failed to delete category: ${errorData.message}`);
      }
    } catch (error) {
      toast.error("An error occurred while deleting category.");
      console.error("Delete category error:", error);
    }
  };
  const openCategoryListModal = () => {
    fetchCategories();
    setIsCategoryListModalOpen(true);
  };

  const fetchProjects = useCallback(async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/projects/getAllProjects`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        console.log("Fetched Projects:", data.projects); // Check data structure
        setProjects(data || []); // Use empty array if undefined
      } else {
        const errorData = await response.json();
        toast.error(`Failed to fetch projects: ${errorData.message}`);
      }
    } catch (error) {
      toast.error("An error occurred while fetching projects.");
      console.error("Fetch projects error:", error);
    }
  }, []);

  useEffect(() => {
    fetchPersons();
    fetchProjects();
  }, [fetchPersons, fetchProjects]);
  const handleDeleteProject = async (id) => {
    const token = localStorage.getItem("token");
    if (!token) {
      toast.error("Please log in to delete a person.");
      navigate("/signIn");
      return;
    }

    try {
      const response = await fetch(
        `${API_BASE_URL}/projects/deleteProject/${id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        toast.success("Project deleted successfully!");
        setProjects((prevProjects) =>
          prevProjects.filter((project) => project._id !== id)
        );
      } else {
        const errorData = await response.json();
        toast.error(`Failed to delete project: ${errorData.message}`);
      }
    } catch (error) {
      toast.error("An error occurred while deleting project.");
      console.error("Delete project error:", error);
    }
  };
  const openProjectListModal = () => {
    fetchProjects();
    setIsProjectListModalOpen(true);
  };

  return (
    <div className="">
      <div className="flex flex-wrap">
        <div className="w-full sm:w-2/2 lg:w-1/2 p-2">
          <div
            className="cursor-pointer rounded-lg bg-white border-l-4 border-themeColor1 p-4 shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px] hover:scale-95 transition-transform"
            onClick={() => setIsProjectModalOpen(true)}
          >
            <div className="flex items-center justify-between">
              <div>
                <h4 className="text-themeColor2 font-semibold mb-0">
                  ADD PROJECT
                </h4>
              </div>
              <div className="widgets-icons-2 rounded-full bg-gradient-to-br from-themeColor1 to-themeColor2 text-white ml-auto flex items-center justify-center w-10 h-10">
                <i class="fa-solid fa-diagram-project"></i>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full sm:w-2/2 lg:w-1/2 p-2">
          <div
            className="cursor-pointer rounded-lg bg-white border-l-4 border-themeColor1 p-4 shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px] hover:scale-95 transition-transform"
            onClick={() => setIsPersonModalOpen(true)}
          >
            <div className="flex items-center justify-between">
              <div>
                <h4 className="text-themeColor2 font-semibold mb-0">
                  ADD PERSON
                </h4>
              </div>
              <div className="widgets-icons-2 rounded-full bg-gradient-to-br from-themeColor1 to-themeColor2 text-white ml-auto flex items-center justify-center w-10 h-10">
                <i class="fa-solid fa-users"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-wrap">
        <div className="w-full sm:w-2/2 lg:w-1/2 p-2">
          <div
            className="cursor-pointer rounded-lg bg-white border-l-4 border-themeColor1 p-4 shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px] hover:scale-95 transition-transform"
            onClick={() => setIsCategoryModalOpen(true)}
          >
            <div className="flex items-center justify-between">
              <div>
                <h4 className="text-themeColor2 font-semibold mb-0">
                  ADD CATEGORY
                </h4>
              </div>
              <div className="widgets-icons-2 rounded-full bg-gradient-to-br from-themeColor1 to-themeColor2 text-white ml-auto flex items-center justify-center w-10 h-10">
                <i className="fa-solid fa-puzzle-piece"></i>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full sm:w-2/2 lg:w-1/2 p-2">
          <div
            className="cursor-pointer rounded-lg bg-white border-l-4 border-themeColor1 p-4 shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px] hover:scale-95 transition-transform"
            onClick={openPersonListModal}
          >
            <div className="flex items-center justify-between">
              <div>
                <h4 className="text-themeColor2 font-semibold mb-0">
                  PERSON LIST
                </h4>
              </div>
              <div className="widgets-icons-2 rounded-full bg-gradient-to-br from-themeColor1 to-themeColor2 text-white ml-auto flex items-center justify-center w-10 h-10">
                <i class="fa-solid fa-address-book"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-wrap">
        <div className="w-full sm:w-2/2 lg:w-1/2 p-2">
          <div
            className="cursor-pointer rounded-lg bg-white border-l-4 border-themeColor1 p-4 shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px] hover:scale-95 transition-transform"
            onClick={openProjectListModal}
          >
            <div className="flex items-center justify-between">
              <div>
                <h4 className="text-themeColor2 font-semibold mb-0">
                  PROJECT LIST
                </h4>
              </div>
              <div className="widgets-icons-2 rounded-full bg-gradient-to-br from-themeColor1 to-themeColor2 text-white ml-auto flex items-center justify-center w-10 h-10">
                <i class="fa-solid fa-list-check"></i>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full sm:w-2/2 lg:w-1/2 p-2">
          <div
            className="cursor-pointer rounded-lg bg-white border-l-4 border-themeColor1 p-4 shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px] hover:scale-95 transition-transform"
            onClick={openCategoryListModal}
          >
            <div className="flex items-center justify-between">
              <div>
                <h4 className="text-themeColor2 font-semibold mb-0">
                  CATEGORY LIST
                </h4>
              </div>
              <div className="widgets-icons-2 rounded-full bg-gradient-to-br from-themeColor1 to-themeColor2 text-white ml-auto flex items-center justify-center w-10 h-10">
                <i class="fa-solid fa-layer-group"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isCategoryModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-80">
            <h3 className="text-lg font-semibold mb-4">Add New Category</h3>
            <input
              type="text"
              value={category}
              onChange={handleCategoryChange}
              className="border p-2 w-full mb-4 bg-gray-100"
              placeholder="Enter category name"
            />
            <div className="flex justify-end mt-10">
              <button
                onClick={() => setIsCategoryModalOpen(false)}
                className="bg-gray-300 text-gray-800 px-4 py-2 rounded mr-2"
              >
                Cancel
              </button>
              <button
                onClick={handleSaveCategory}
                className="bg-themeColor1 text-themeColor2 hover:bg-themeColor2 hover:text-themeColor1 px-4 py-2 rounded"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
      {isPersonModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-80">
            <h3 className="text-lg font-semibold mb-4">Add New Person</h3>
            <input
              type="text"
              value={person}
              onChange={handlePersonChange}
              className="border p-2 w-full mb-4 bg-gray-100"
              placeholder="Enter person name"
            />
            <div className="flex justify-end mt-10">
              <button
                onClick={() => setIsPersonModalOpen(false)}
                className="bg-gray-300 text-gray-800 px-4 py-2 rounded mr-2"
              >
                Cancel
              </button>
              <button
                onClick={handleSavePerson}
                className="bg-themeColor1 text-themeColor2 px-4 py-2 hover:bg-themeColor2 hover:text-themeColor1 rounded"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
      {isProjectModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-80">
            <h3 className="text-lg font-semibold mb-4">Add New Project</h3>
            <input
              type="text"
              value={project}
              onChange={handleProjectChange}
              className="border p-2 w-full mb-4 bg-gray-100"
              placeholder="Enter project name"
            />
            <div className="flex justify-end mt-10">
              <button
                onClick={() => setIsProjectModalOpen(false)}
                className="bg-gray-300 text-gray-800 px-4 py-2 rounded mr-2"
              >
                Cancel
              </button>
              <button
                onClick={handleSaveProject}
                className="bg-themeColor1 text-themeColor2 px-4 py-2 hover:bg-themeColor2 hover:text-themeColor1 rounded"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
      {isPersonListModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-80">
            <h3 className="text-lg font-semibold mb-4">Person List</h3>
            {/* Safely check if persons is an array and has length */}
            {Array.isArray(persons) && persons.length > 0 ? (
              <ul className="space-y-2">
                {persons.map((personItem) => (
                  <li
                    key={personItem._id}
                    className="flex justify-between items-center"
                  >
                    <span>{personItem.person}</span>
                    <Popconfirm
                      title="Are you sure you want to delete?"
                      onConfirm={() => handleDeletePerson(personItem._id)}
                      okText="Yes"
                      cancelText="No"
                    >
                      <i className="fa-solid fa-trash text-red-500 hover:text-red-700"></i>
                    </Popconfirm>
                  </li>
                ))}
              </ul>
            ) : (
              <p>No persons found.</p>
            )}
            <div className="flex justify-end mt-4">
              <button
                onClick={() => setIsPersonListModalOpen(false)}
                className="bg-gray-300 text-gray-800 px-4 py-2 rounded mr-2"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {isProjectListModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-80">
            <h3 className="text-lg font-semibold mb-4">Project List</h3>
            {/* Safely check if projects is an array and has length */}
            {Array.isArray(projects) && projects.length > 0 ? (
              <ul className="space-y-2">
                {projects.map((projectItem) => (
                  <li
                    key={projectItem._id}
                    className="flex justify-between items-center"
                  >
                    <span>{projectItem.project}</span>
                    <Popconfirm
                      title="Are you sure you want to delete?"
                      onConfirm={() => handleDeleteProject(projectItem._id)}
                      okText="Yes"
                      cancelText="No"
                    >
                      <i className="fa-solid fa-trash text-red-500 hover:text-red-700"></i>
                    </Popconfirm>
                  </li>
                ))}
              </ul>
            ) : (
              <p>No projects found.</p>
            )}
            <div className="flex justify-end mt-4">
              <button
                onClick={() => setIsProjectListModalOpen(false)}
                className="bg-gray-300 text-gray-800 px-4 py-2 rounded mr-2"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {isCategoryListModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-80">
            <h3 className="text-lg font-semibold mb-4">Category List</h3>
            {/* Safely check if projects is an array and has length */}
            {Array.isArray(categories) && categories.length > 0 ? (
              <ul className="space-y-2">
                {categories.map((categoryItem) => (
                  <li
                    key={categoryItem._id}
                    className="flex justify-between items-center"
                  >
                    <span>{categoryItem.category}</span>
                    <Popconfirm
                      title="Are you sure you want to delete?"
                      onConfirm={() => handleDeleteCategory(categoryItem._id)}
                      okText="Yes"
                      cancelText="No"
                    >
                      <i className="fa-solid fa-trash text-red-500 hover:text-red-700"></i>
                    </Popconfirm>
                  </li>
                ))}
              </ul>
            ) : (
              <p>No category found.</p>
            )}
            <div className="flex justify-end mt-4">
              <button
                onClick={() => setIsCategoryListModalOpen(false)}
                className="bg-gray-300 text-gray-800 px-4 py-2 rounded mr-2"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

export default Setting;
